export const ru = (__LOCALE_RU__ ? ({
  facePage: {
    header: {
      title: 'Детали лица',
      breadcrumbs: {
        cards_and_lists: 'Картотека и списки',
        card: 'Карточка',
        face: 'Детали лица',
      },
    },
    general_info: {
      header: 'Общая информация',
      data: {
        create_time: 'Создано',
        external_id: 'ID карточки',
        lists: 'Списки',
        user_data: 'Информация',
        face_id: 'ID лица',
      },
    },
    additional_info: {
      switches: {
        attributes: 'Атрибуты',
        additional: 'Дополнительные свойства',
      },
    },
    'face info': {
      'card ID': 'ID карточки',
    },
    edit_face_info: {
      title: 'Редактирование информации о лице',
      replace_photo: 'Заменить фото',
      lists_label: 'Списки',
      information_label: 'Информация',
      success_toast: 'Информация успешно обновлена',
      card_label: 'Карточка',
      lists_hint: 'Для изменения списков перейдите в карточку',
      edit_face_button: 'Изменить данные',
    },
    same_external_id_faces: {
      title: 'Лица с тем же ID карточки',
      no_faces: 'Лица с тем же ID карточки не зарегистрированы в системе',
    },
    latest_face_events: {
      title: 'Последние события с лицом',
      no_events: 'События с данным лицом не зарегистрированы в системе',
      show_more: 'Показать ещё',
    },
    meta_information: {
      title: 'Дополнительные сведения',
      no_meta: 'Нет данных',
      download_as_json: 'Скачать JSON',
    },
    common: {
      save: 'Сохранить',
      cancel: 'Отмена',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  facePage: {
    header: {
      title: 'Face details',
      breadcrumbs: {
        cards_and_lists: 'Card index and lists',
        card: 'Card',
        face: 'Face details',
      },
    },
    general_info: {
      header: 'General information',
      data: {
        create_time: 'Created',
        external_id: 'Card ID',
        lists: 'Lists',
        user_data: 'Information',
        face_id: 'Face ID',
      },
    },
    additional_info: {
      switches: {
        attributes: 'Attributes',
        additional: 'Additional properties',
      },
    },
    'face info': {
      'card ID': 'Card ID',
    },
    edit_face_info: {
      title: 'Edit Face Information',
      replace_photo: 'Replace photo',
      lists_label: 'Lists',
      information_label: 'Information',
      success_toast: 'Information has been successfully updated.',
      card_label: 'Card',
      lists_hint: 'To edit lists, go to the card',
      edit_face_button: 'Edit face info',
    },
    same_external_id_faces: {
      title: 'Faces with same card ID',
      no_faces: 'Faces with same card ID is not registered in the system',
    },
    latest_face_events: {
      title: 'Latest events with the face',
      no_events: 'Latest events with the face is not registered in the system',
      show_more: 'Show more',
    },
    meta_information: {
      title: 'Additional information',
      no_meta: 'No data',
      download_as_json: 'download JSON',
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
    },
  },
}) : {}) as Record<string, unknown>;
